import React from 'react';
import { progressBlock } from './constants';
export function ProgressInnerText(props) {
    const { text, offset = 0 } = props;
    if (!text) {
        return null;
    }
    return (React.createElement("div", { className: progressBlock('text-inner'), style: { transform: `translateX(calc(var(--g-flow-direction) * ${-offset}%))` } }, text));
}
